import { Head, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = {
    status?: string | null;
};

export default function Verify({ status }: Props) {
    const form = useForm({});

    function resend(e: React.FormEvent) {
        e.preventDefault();
        form.post('/email/verification-notification');
    }

    return (
        <PublicLayout>
            <Head title="Verify your email" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[28px] leading-tight text-ink mb-3">Check your email</h1>
                <p className="text-ink-soft text-[14px]">
                    We sent a verification link to your inbox. Click it to activate your account.
                </p>
                {status === 'verification-link-sent' && (
                    <div className="mt-4 text-[14px] text-emerald-700">
                        A new verification link has been sent.
                    </div>
                )}
                <form onSubmit={resend} className="mt-6">
                    <Btn type="submit" loading={form.processing}>Resend link</Btn>
                </form>
            </div>
        </PublicLayout>
    );
}
